require('./RAManagementPlanView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const ReactDOM = require('react-dom');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
const classnames = require('classnames');

// @commons
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { AmountInput } = require('commonsComponents/amountInput');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const { OKInput } = require('commonsComponents/OKInput');
const BrokerEditAlias = require('components/commons/broker/brokerEditAlias/brokerEditAlias');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAStrategyCards = require('../../components/RAStrategyCards/RAStrategyCards');
const RARoboStrategyCards = require('../../components/RARoboStrategyCards/RARoboStrategyCards');
const RAPortfolioDonut = require('../../components/RAPortfolioDonut/RAPortfolioDonut');
const RAPortfolioCompositionTable = require('../../components/RAPortfolioCompositionTable/RAPortfolioCompositionTable');
const RAExpectedProfitability = require('../../components/RAExpectedProfitability/RAExpectedProfitability');
const RAContributionPeriodicity = require('../../components/RAContributionPeriodicity/RAContributionPeriodicity');
const RAOKCover = require('../../components/commons/RAOKCover/RAOKCover');
const RAImageButton = require('../../components/commons/RAImageButton/RAImageButton');
const RAImageButtonGroup = require('../../components/commons/RAImageButtonGroup/RAImageButtonGroup');
const RAIndexRiskModal = require('../../components/RAIndexRiskModal/RAIndexRiskModal');
const RATimeHorizonCheck = require('../../components/RATimeHorizonCheck/RATimeHorizonCheck');
const RAStrategiesGraph = require('../../components/RAStrategiesGraph/RAStrategiesGraph');
const RACommissionCondition = require('../../components/RACommissionCondition/RACommissionCondition');
const RASaveSimulationModal = require('../../components/RASaveSimulationModal/RASaveSimulationModal');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const RARiskButton = require('../../components/RARiskButton/RARiskButton');
const RAEmailRequiredWarning = require('../../components/contactCenter/RAEmailRequiredWarning/RAEmailRequiredWarning');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');
const {
    ModalUsPersonBlock,
} = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @actions
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raManagementPlanActions = require('../../actions/RAManagementPlan');
const raSaveSimulationActions = require('../../actions/RASaveSimulation');
const raSuitabilityTestActions = require('../../actions/RASuitabilityTest');
const raSetGoalActions = require('../../actions/RASetGoal');
const raTimeHorizonCheckActions = require('../../actions/RATimeHorizonCheck');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const notification = require('actions/notifications');
const raCustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');
const raPortfoliosNameHistoryActions = require('../../actions/RAPortfoliosNameHistory');

// @utilites
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const {
    recordLink,
    recordProcess,
    recordLinkV2,
} = require('utilities/tagging');
const RAScrollUtils = require('../../utilities/RAScrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { RA_MANAGEMENT_PLAN } = require('utilities/tagging');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @constants
const {
    CONTENT_TYPE_PDF,
    EURO_SYMBOL,
    MYPROFILE_BROKER_URL,
    DATE_FORMAT_API,
    SECOND_STEP,
    BROKER_ROBO_EDIT_FIELD_FONT,
    BROKER_PG_ROBO_URL,
} = require('constants/index');

const {
    ROBO_PRECONTRACT,
    ESG_PRODUCT,
    ROBO_ZERO_COMMISSION,
    WEALTH_SEPBLAC_BLOCKED_ACCOUNTS,
    SUITABILITY_HIRE_MAINTENANCE_POPUP,
} = require('constants/flagBasedFeatures');

const {
    CONTRIBUTION_PERIOD_MONTHLY,
    DATE_FORMAT_TIME_HORIZON_CHECK,
    HIRE_GBI_URL,
    HIRE_PLAN_URL,
    MANAGEMENT_PLAN_URL,
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MYPROFILE_BROKER_ROBO_URL,
    PROC_RA_MANAGMENT_PLAN_ACCORDION_OBJECTIVES,
    PROC_RA_MANAGMENT_PLAN_CLEAN_STRATEGY,
    PROC_RA_MANAGMENT_PLAN_HIRE,
    PROC_RA_MANAGMENT_PLAN_LIQUIDITY_TOOLTIP,
    PROC_RA_MANAGMENT_PLAN_MANAGMENT_CONTRACT,
    PROC_RA_MANAGMENT_PLAN_MODIFY_OBJECTIVE_NAME,
    PROC_RA_MANAGMENT_PLAN_NO_OBJECTIVE,
    PROC_RA_MANAGMENT_PLAN_OPEN_CLOSE,
    PROC_RA_MANAGMENT_PLAN_OPEN_MODAL,
    PROC_RA_MANAGMENT_PLAN_RISK_INDEX,
    PROC_RA_MANAGMENT_PLAN_SAVE,
    PROC_RA_MANAGMENT_PLAN_SAVE_STRATEGY,
    PROC_RA_MANAGMENT_PLAN_SELECT_STRATEGY,
    PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_BANNER,
    PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_FOOTER,
    PROC_RA_MANAGMENT_PLAN_SIMULATOR_INTERACTION,
    PROC_RA_MANAGMENT_PLAN_WALLET_DETAILS,
    PROC_RA_MANAGMENT_PLAN,
    PROC_RA_MODIFY_WALLET_NAME,
    PROC_RA_YEARS,
    RA_DATEPICKER_MAXIMUM_YEARS,
    RA_MANAGEMENT_PLAN_VIEW,
    RA_NO_STRATEGY_SELECTED,
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    RA_SAVE_SIMULATION_PORTFOLIO_ERROR_ID,
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT,
    RA_SIMULATION_SCROLL_BUFFER,
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_NOT_PERFORMED,
    TIME_HORIZON_CHECK_WARNING,
} = require('../../raConstants/index');

const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_DATE_FORMAT,
    DATE_PICKER_CUSTOM_LOCALE,
} = require('constants/commonsComponents');
const RAStrategyDetailModal = require('../../components/RAStrategyDetailModal/RAStrategyDetailModal');

class RAManagementPlanView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            titleEditor: false,
            isExpandedObjectives: false,
            isModalOpen: false,
            showStrategyDetailModal: false,
            msgFlag: false,
            openModalMaintenance: false,
        };
        this.handleAccordionObjectivesClick = this.handleAccordionObjectivesClick.bind(
            this,
        );
        this.handleDeleteSimulation = this.handleDeleteSimulation.bind(this);
        this.handleProjectionChartYearsClick = this.handleProjectionChartYearsClick.bind(
            this,
        );
        this.handleOnHoverLiquidity = this.handleOnHoverLiquidity.bind(this);
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
        this.handleContributionDayChange = this.handleContributionDayChange.bind(
            this,
        );
        this.handleCustomNameChange = this.handleCustomNameChange.bind(this);
        this.handleStrategyDetailsClick = this.handleStrategyDetailsClick.bind(
            this,
        );
        this.handleSave = this.handleSave.bind(this);
        this.handleManagementPDFClick = this.handleManagementPDFClick.bind(
            this,
        );
        this.handleInitialContributionChange = this.handleInitialContributionChange.bind(
            this,
        );
        this.handleRecurringContributionChange = this.handleRecurringContributionChange.bind(
            this,
        );
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleEndDateError = this.handleEndDateError.bind(this);
        this.handleStrategyResetClick = this.handleStrategyResetClick.bind(
            this,
        );
        this.handleTitleBlur = this.handleTitleBlur.bind(this);
        this.handleTitleFocus = this.handleTitleFocus.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleStrategyClick = this.handleStrategyClick.bind(this);
        this.handleGetImageClicked = this.handleGetImageClicked.bind(this);
        this.buildModal = this.buildModal.bind(this);
        this.handleOnLinkClick = this.handleOnLinkClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.shortStrategyNumber = this.shortStrategyNumber.bind(this);
        this.handleTimeHorizonCheck = this.handleTimeHorizonCheck.bind(this);
        this.handleSaveSimulation = this.handleSaveSimulation.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleGoalResetClick = this.handleGoalResetClick.bind(this);
        this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
        this.handleStrategyModalClose = this.handleStrategyModalClose.bind(
            this,
        );
        this.handleCloseModalMaintenance = this.handleCloseModalMaintenance.bind(
            this,
        );
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
        document.addEventListener('click', this.handleAccordionToggle);

        const {
            immProfile,
            fetchFeatureFlag,
            featureModalToggle,
            immRAFeatureFlag,
            getDisplayNames,
            getPDFContract,
            getTestResult,
            history,
            requestPortfolioDistribution,
            requestSimulation,
            immFlagBasedFeatures,
            validateBlockedAccount,
        } = this.props;

        if (!immFlagBasedFeatures.get(WEALTH_SEPBLAC_BLOCKED_ACCOUNTS)) {
            validateBlockedAccount(history);
        }
        requestSimulation(true);
        getTestResult();
        requestPortfolioDistribution();
        getPDFContract(history);
        getDisplayNames();
        //Added then becuase we need to show model on loading and After API call gets successful
        const email = PersonalDataHelper.getEmail(immProfile);
        fetchFeatureFlag().then(() => {
            if (!immRAFeatureFlag.get('purchase')) {
                !(!email && __CONTACT_CENTER__) && featureModalToggle(); //email warning model will be shown only
            }
        });
        const profileId = this.props.immSaveSimulation.getIn([
            'saveSimulationPortfolio',
            'newProfile',
        ]);
        if (!!profileId && profileId != RA_SAVE_SIMULATION_PORTFOLIO_ERROR_ID) {
            !(!email && __CONTACT_CENTER__) &&
                this.props.saveSimulationChangeModalOption(true); //email warning model will be shown only
        }
        const customData = {
            event_name: 'step_product_details',
            pageName: '/applicationRobo/step0/productDetails',
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'applicationRobo',
            processStep: 'step0',
            processDetail: 'productDetails',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);

        const isHireMaintenancePopup = immFlagBasedFeatures.get(
            SUITABILITY_HIRE_MAINTENANCE_POPUP,
        );
        if (isHireMaintenancePopup) {
            this.setState({
                openModalMaintenance: true,
            });
            recordLinkV2({
                action: 'open',
                format: 'modal',
                component: 'modal/technicalUpdateDeferOperations',
                element: 'full',
                eventCategory: PROC_RA_MANAGMENT_PLAN,
                eventAction: 'technicalUpdateDeferOperations',
                eventLabel: 'full',
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immManagementPlan,
            immCustomPlanByObjective,
            immPortfoliosNameHistory,
            immTimeHorizonCheck,
            immCheckStatus,
            history,
        } = this.props;

        if (immManagementPlan.get('errorFlags')) {
            const injectedStrings = [
                MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
            ];
            const message = formatText(
                'rainput-amoutInputMinimumValidation',
                injectedStrings,
            );
            recordLinkV2({
                eventCategory: 'error',
                eventAction: 'importe erróneo',
                eventLabel: message,
            });
        }

        const isFetchingCheckStatus = immCheckStatus.get(
            'isFetchingCheckStatus',
        );
        const nonSuitableTest = immCheckStatus.get('nonSuitableTest');

        if (!isFetchingCheckStatus && nonSuitableTest) {
            history.push('myprofile/robo/test');
        }

        const immPrevManagementPlan = prevProps.immManagementPlan;
        const immPrevCustomPlanByObjective = prevProps.immCustomPlanByObjective;
        const recurringContributionAmount = immManagementPlan.get(
            'recurringContributionAmount',
        );
        const initialContributionAmount = immManagementPlan.get(
            'initialContributionAmount',
        );
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        const periodicity = immManagementPlan.get('periodicity');
        const recurringContributionDay = immManagementPlan.get(
            'recurringContributionDay',
        );
        const objectiveTitle = immCustomPlanByObjective.get('objective');
        const selectedGoal = immCustomPlanByObjective.get('objectiveType');
        const isStrategySelected = immManagementPlan.get('investProfileValue');
        const initialContributionAmountError = immManagementPlan.get(
            'initialContributionAmountError',
        );
        const recurringAmountError = immManagementPlan.get(
            'recurringAmountError',
        );
        const initialContributionAmountUpdate =
            immPrevManagementPlan.get('initialContributionAmount') !==
            initialContributionAmount;
        const recurringContributionAmountUpdate =
            immPrevManagementPlan.get('recurringContributionAmount') !==
            recurringContributionAmount;
        const objectiveAmountUpdate =
            immPrevCustomPlanByObjective.get('objectiveAmount') !==
            objectiveAmount;
        const periodicityUpdate =
            immPrevManagementPlan.get('periodicity') != periodicity;
        const recurringContributionDayUpdate =
            immPrevManagementPlan.get('recurringContributionDay') !==
            recurringContributionDay;
        const objectiveUpdate =
            immPrevCustomPlanByObjective.get('objective') !== objectiveTitle;
        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const prevObjectiveEndDate = immPrevCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const objectiveEndDateUpdate =
            objectiveEndDate && !objectiveEndDate.isSame(prevObjectiveEndDate);
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const portfolioCustomName = immManagementPlan.get(
            'portfolioCustomName',
        );
        const customNameHistoryError =
            namesHistory &&
            namesHistory.find(
                names =>
                    names &&
                    names.toLowerCase() === portfolioCustomName.toLowerCase(),
                false,
            );
        const customNameEmptyError =
            !selectedGoal && portfolioCustomName === '';
        const customNameError = customNameHistoryError || customNameEmptyError;
        const objectiveNameHistoryError = namesHistory.find(
            names =>
                names && names.toLowerCase() === objectiveTitle.toLowerCase(),
            false,
        );
        const objectiveNameEmptyError = selectedGoal && objectiveTitle === '';
        const objectiveNameError =
            objectiveNameHistoryError || objectiveNameEmptyError;
        if (customNameError || objectiveNameError) {
            this.props.disableSaveSimulationButton(true);
        }
        const isScrollHeightSet = immManagementPlan.get('isScrollHeightSet');

        if (
            isStrategySelected &&
            (initialContributionAmountUpdate ||
                recurringContributionAmountUpdate ||
                objectiveAmountUpdate ||
                periodicityUpdate ||
                recurringContributionDayUpdate ||
                objectiveUpdate ||
                objectiveEndDateUpdate)
        ) {
            this.setSaveSimulationButtonEnabled();
        }
        const finishedFetching =
            !immManagementPlan.get('isFetchingInvestProfile') &&
            immPrevManagementPlan.get('isFetchingInvestProfile');
        if (finishedFetching) {
            const selectedStrategy = immManagementPlan.get(
                'investProfileValue',
            );
            const hasBarGraphData =
                (!!initialContributionAmount ||
                    !!recurringContributionAmount) &&
                !!objectiveAmount &&
                !!objectiveEndDate;
            const hasProjectionChartData =
                !!selectedStrategy && !!initialContributionAmount;

            if (hasBarGraphData) {
                this.requestBarChart();
            }
            if (!!objectiveEndDate) {
                this.props.timeHorizonCheck(() => {}, this.shortStrategyNumber);
            }

            if (hasProjectionChartData) {
                const recurringContributionAmount = immManagementPlan.get(
                    'recurringContributionAmount',
                );
                const periodicity = immManagementPlan.get('periodicity');
                const recurringContributionDay = immManagementPlan.get(
                    'recurringContributionDay',
                );
                this.props.requestProjectionChart({
                    freq: recurringContributionAmount > 0 ? periodicity : 1,
                    mntPayment: recurringContributionAmount,
                    cutDay:
                        periodicity === CONTRIBUTION_PERIOD_MONTHLY
                            ? recurringContributionDay
                            : 1,
                    product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                });
            }
            if (objectiveEndDateUpdate) {
                this.props.timeHorizonCheck(() => {}, this.shortStrategyNumber);
            }
        }

        if (
            (initialContributionAmountUpdate ||
                recurringContributionAmountUpdate) &&
            !initialContributionAmountError &&
            !recurringAmountError
        ) {
            this.requestLineChart();
            this.requestBarChart();
        }

        if (!isScrollHeightSet) {
            this.props.setScrollHeight();
        }

        if ((objectiveEndDate === null) & (prevObjectiveEndDate !== null)) {
            this.props.resetMaxTypeOfProduct();
        }

        const maxInvestProfileValue = immTimeHorizonCheck.get(
            'maxTypeOfProduct',
        );
        if (
            maxInvestProfileValue <
                immManagementPlan.get('investProfileValue') &&
            !selectedGoal
        ) {
            this.handleStrategyClick(maxInvestProfileValue);
        }

        const prevPortfolioname = prevProps.immManagementPlan.get(
            'portfolioCustomName',
        );

        if (portfolioCustomName && portfolioCustomName !== prevPortfolioname) {
            const newCustomData = {
                event_name: 'step_product_details',
                pageName: '/applicationRobo/step0/productDetails',
                sectionFamily: 'wealth',
                sectionCategory: 'products',
                sectionName: 'robo',
                serviceType: 'productContracting',
                interactionType: 'funnel',
                processType: 'applicationRobo',
                processStep: 'step0',
                processDetail: 'productDetails',
                productName: portfolioCustomName,
            };
            window &&
                window.utag &&
                window.utag.view &&
                window.utag.view(newCustomData);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('click', this.handleAccordionToggle);
        this.props.reset();
        this.props.resetMaxTypeOfProduct();
        RAScrollUtils.resetElems();
    }

    handleOnHoverLiquidity() {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_LIQUIDITY_TOOLTIP,
        );
    }

    handleAccordionObjectivesClick(isExpanded) {
        if (isExpanded != this.state.isExpandedObjectives) {
            this.setState({ isExpandedObjectives: isExpanded });
            recordLink(
                PROC_RA_MANAGMENT_PLAN,
                PROC_RA_MANAGMENT_PLAN_ACCORDION_OBJECTIVES,
                PROC_RA_MANAGMENT_PLAN_OPEN_CLOSE,
            );
        }
    }

    handleAccordionToggle(e) {
        const golaSectionNode = ReactDOM.findDOMNode(this.raGoalSectionHeader);

        if (golaSectionNode && golaSectionNode.contains(e.target)) {
            setTimeout(() => {
                this.props.resetScrollHeight();
            }, 400);
        }
    }

    handleScroll() {
        const {
            immCustomPlanByObjective,
            immExpectedProfitability,
            immManagementPlan,
            immTimeHorizonCheck,
        } = this.props;
        // we need to avoid next ejecution because th DOM isn't ready yet showing loading and fire error
        if (immManagementPlan.get('isFetchingValidateBlockedAccount')) return;
        const ctaFooterSection = ReactDOM.findDOMNode(this.raCtaFooter);
        const raFooterSectionNode = ReactDOM.findDOMNode(this.raFooter);
        const pageScrollHeight = RAScrollUtils.getPageScrollHeight();
        const initialContributionAmount = immManagementPlan.get(
            'initialContributionAmount',
        );
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        const immProductsChartData = immExpectedProfitability.get(
            'barChartData',
        );
        const status = immTimeHorizonCheck.get('status');
        let contribution;

        if (immProductsChartData) {
            contribution = immProductsChartData.getIn([
                0,
                1,
                'contributionNet',
            ]);
        }
        const displayStrategyMessage =
            (contribution > objectiveAmount ||
                initialContributionAmount > objectiveAmount) &&
            ![
                TIME_HORIZON_CHECK_NOT_PERFORMED,
                TIME_HORIZON_CHECK_ERROR,
                TIME_HORIZON_CHECK_WARNING,
            ].includes(status);

        const scrollBuffer = displayStrategyMessage
            ? 120
            : RA_SIMULATION_SCROLL_BUFFER;

        if (__CONTACT_CENTER__) {
            RAScrollUtils.scrollHandler(
                RA_MANAGEMENT_PLAN_VIEW,
                ctaFooterSection,
                pageScrollHeight,
                scrollBuffer,
                raFooterSectionNode,
            );
        }
    }

    requestBarChart() {
        const { requestProjectionChart } = this.props;

        requestProjectionChart({
            dataPoints: 2,
            chartYears: 0,
            product: RA_PROJECTION_CHART_ALL_PRODUCTS,
        });
    }

    requestLineChart() {
        const { immManagementPlan } = this.props;
        const selectedStrategy = immManagementPlan.get('investProfileValue');

        if (!!selectedStrategy) {
            this.props.requestProjectionChart({
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
            });
        }
    }

    handleStrategyResetClick() {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_CLEAN_STRATEGY,
        );
        this.props.reset();
        this.props.resetGoal();
        this.props.resetMaxTypeOfProduct();
    }

    handleGoalResetClick() {
        this.props.resetGoal();
        this.props.resetMaxTypeOfProduct();
        recordLinkV2({
            eventCategory: 'proc-robo-set-goal',
            eventAction: 'clickButton',
            eventLabel: 'rehacer objetivo',
        });
    }

    handleProjectionChartYearsClick(value) {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_SIMULATOR_INTERACTION,
            value + PROC_RA_YEARS,
        );
        this.props.expectedProfitabilityChangeYears(value);
        this.requestLineChart();
    }

    handleGetImageClicked(goalSelected) {
        const {
            updateGoalSelected,
            resetGoal,
            resetMaxTypeOfProduct,
            immManagementPlan,
            immTimeHorizonCheck,
            updateCustomName,
        } = this.props;

        const isStrategySelected = immManagementPlan.get('investProfileValue');
        if (isStrategySelected) {
            this.setSaveSimulationButtonEnabled();
        }

        if (goalSelected.isSelected) {
            resetGoal();
            resetMaxTypeOfProduct();
            if (isStrategySelected) {
                updateCustomName(isStrategySelected);
            }
        } else {
            updateGoalSelected(goalSelected);
        }

        const isFetching = immTimeHorizonCheck.get('isFetching');
        if (!isFetching) {
            this.props.resetScrollHeight();
        }
    }

    handleInitialContributionChange(value) {
        const { immManagementPlan, setInitialContributionAmount } = this.props;
        if (immManagementPlan.get('initialContributionAmount') !== value) {
            setInitialContributionAmount(value);
        }
    }

    handleRecurringContributionChange(value) {
        const {
            immManagementPlan,
            setRecurringContributionAmount,
        } = this.props;
        if (immManagementPlan.get('recurringContributionAmount') !== value) {
            setRecurringContributionAmount(value);
        }
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
                redirectionLink={MYPROFILE_BROKER_ROBO_URL}
            />
        );
    }

    shortStrategyNumber() {
        const { immTimeHorizonCheck, immManagementPlan } = this.props;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const selectedStrategy = immManagementPlan.get('investProfileValue');

        if (
            maxTypeOfProduct < selectedStrategy &&
            selectedStrategy !== RA_NO_STRATEGY_SELECTED
        ) {
            this.props.selectStrategy(RA_NO_STRATEGY_SELECTED);
        }
    }

    handleTimeHorizonCheck(type, wealthRoboStrategiesEnabled) {
        const {
            history,
            immCustomPlanByObjective,
            immManagementPlan,
            saveSimulation,
            timeHorizonCheck,
        } = this.props;

        const includedGoal = !!immCustomPlanByObjective.get('objectiveType');
        const selectedStrategy = immManagementPlan.get('investProfileValue');
        const actionEvent =
            type === 'banner'
                ? PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_BANNER
                : PROC_RA_MANAGMENT_PLAN_SET_STRATEGY_FOOTER;

        const customData = {
            event_name: 'event_success',
            action: wealthRoboStrategiesEnabled ? 'click' : 'success',
            format: wealthRoboStrategiesEnabled ? 'button' : 'steps',
            component: wealthRoboStrategiesEnabled
                ? 'strategySelection'
                : 'funnel',
            element: wealthRoboStrategiesEnabled ? 'hire' : 'productDetails',
        };

        const recordEvent = (eventName, eventTag) => {
            recordLinkV2({
                eventCategory: PROC_RA_MANAGMENT_PLAN,
                eventName,
                eventTag,
                ...customData,
            });
        };

        if (includedGoal) {
            const selectedObjective = immCustomPlanByObjective.get(
                'objectiveType',
            );
            const selectedEndDate = moment(
                immCustomPlanByObjective.get('objectiveEndDate'),
            ).format(DATE_FORMAT_API);

            recordEvent(
                actionEvent,
                `${selectedStrategy} ${selectedObjective} ${selectedEndDate}`,
            );

            timeHorizonCheck(() => {
                saveSimulation(history);
                history.push(HIRE_GBI_URL);
            }, this.shortStrategyNumber);
        } else {
            saveSimulation(history);

            const eventTag = wealthRoboStrategiesEnabled
                ? PROC_RA_MANAGMENT_PLAN_HIRE
                : `${selectedStrategy} ${PROC_RA_MANAGMENT_PLAN_NO_OBJECTIVE}`;

            recordEvent(
                wealthRoboStrategiesEnabled
                    ? PROC_RA_MANAGMENT_PLAN_SELECT_STRATEGY
                    : actionEvent,
                eventTag,
            );
            history.push(HIRE_PLAN_URL);
        }
    }

    handlePeriodicityChange(ev) {
        const { setPeriodicity } = this.props;
        setPeriodicity(ev.value);
        this.requestLineChart();
        this.requestBarChart();
    }

    handleContributionDayChange(ev) {
        const { immManagementPlan } = this.props;
        const selectedDay = parseInt(ev.currentTarget.dataset.id);
        if (selectedDay !== immManagementPlan.get('recurringContributionDay')) {
            this.props.setContributionDay(selectedDay);
            this.requestLineChart();
            this.requestBarChart();
        }
    }

    handleManagementPDFClick() {
        const documentContent = this.props.immHireManagementPlan.get('pdfLink');
        const documentName = formatText(
            'raManagementPlan-downloadContractDocument',
        );
        const documentToDownload = `${documentName}.pdf`;
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_MANAGMENT_CONTRACT,
        );
        downloadAsFile(
            base64ToBlob(documentContent),
            CONTENT_TYPE_PDF,
            documentToDownload,
        );
    }

    handleStrategyDetailsClick(wealthRoboStrategiesEnabled) {
        const { immManagementPlan, showDetails } = this.props;

        this.recordWalletDetails(immManagementPlan.get('portfolioCustomName'));

        if (wealthRoboStrategiesEnabled) {
            this.openStrategyDetailModal();
        } else {
            this.scrollToDetailsSection(showDetails);
        }
    }

    recordWalletDetails(portfolioCustomName) {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_WALLET_DETAILS,
            portfolioCustomName,
        );
    }

    openStrategyDetailModal() {
        this.setState({ showStrategyDetailModal: true });
    }

    handleStrategyModalClose() {
        this.setState({ showStrategyDetailModal: false });
    }

    scrollToDetailsSection(showDetails) {
        showDetails();

        setTimeout(() => {
            const elementTo = document.querySelector(
                '#raManagementPlanViewDetailsAnchor',
            );
            if (elementTo) {
                window.scrollTo(0, elementTo.offsetTop - 150);
            }
        }, 200);
    }

    handleSave() {
        this.props.saveSimulation(this.props.history);
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    handleCustomNameChange(evt) {
        recordLink(PROC_RA_MANAGMENT_PLAN, PROC_RA_MODIFY_WALLET_NAME);
        this.props.setCustomName(evt);
        this.setSaveSimulationButtonEnabled();
    }

    buildCustomNameInput(portfolioCustomName, namesHistory) {
        const {
            immCustomPlanByObjective,
            immManagementPlan,
            immTimeHorizonCheck,
        } = this.props;
        const selectedGoal = immCustomPlanByObjective.get('objectiveType');
        const strategyValue = immManagementPlan.get('investProfileValue');
        const status = immTimeHorizonCheck.get('status');
        const isTimeHorizonCheckWarning = status === TIME_HORIZON_CHECK_WARNING;
        const sectionInvestClassName = classnames(
            'ra-management-plan-view__widget-custom-name',
            {
                'ra-management-plan-view__widget-custom-name--disabled':
                    (!isTimeHorizonCheckWarning && selectedGoal) ||
                    !strategyValue,
            },
        );
        const iconClassName = classnames(
            'ra-management-plan-view__widget-custom-name-icon-product',
            {
                [`ra-management-plan-view__widget-custom-name-icon-product--${strategyValue}`]: strategyValue,
                'ra-management-plan-view__widget-custom-name-icon-product--default icon icon-carteras-tower': !strategyValue,
            },
        );
        const nameError =
            !selectedGoal &&
            namesHistory &&
            namesHistory.find(
                names =>
                    names &&
                    names.toLowerCase() === portfolioCustomName.toLowerCase(),
                false,
            );
        const emptyNameError =
            portfolioCustomName === '' && !!strategyValue && !selectedGoal;
        let errorMessage = 'raManagementPlan-raManagementPlan_customNameError';
        if (emptyNameError) {
            errorMessage =
                'raManagementPlan-raManagementPlan_customNameEmptyError';
        }
        return (
            <div className={sectionInvestClassName}>
                <div className={iconClassName} />
                <div className="ra-management-plan-view__widget-custom-name--value ra-management-plan-view__placeholder">
                    <h1 className="profile-picture-editor__alias-edit">
                        <BrokerEditAlias
                            alias={portfolioCustomName}
                            aliasPlaceHolder={formatText(
                                'raManagementPlan-raManagementPlan_customNamePlaceholder',
                            )}
                            allowMaxLength={true}
                            limit={50}
                            allowEmptyAlias={true}
                            postAlias={this.handleCustomNameChange} // eslint-disable-line
                            fontSize={BROKER_ROBO_EDIT_FIELD_FONT}
                            error={nameError || emptyNameError}
                            errorMessage={formatText(errorMessage)}
                        />
                    </h1>
                </div>
            </div>
        );
    }

    buildInitialInvestmentInput(initialInvestment) {
        const { immManagementPlan } = this.props;
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];
        return (
            <div className="ra-management-plan-view__initial-investment-input">
                <div className="ra-management-plan-view__info">
                    <FormattedText
                        value="raManagementPlan-initialInvestment"
                        className="ra-management-plan-view__primary-info"
                    />
                </div>
                <div className="ra-management-plan-view__amount-input">
                    <AmountInput
                        amount={initialInvestment}
                        label={formatText('raManagementPlan-amount')}
                        max={MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT}
                        min={0}
                        fluid={true}
                        language={getLanguage()}
                        callback={this.handleInitialContributionChange} // eslint-disable-line
                        instructionsMessage={formatText(
                            'raManagementPlan-instructionInitialInvestment',
                        )}
                        hideFocusZero={true}
                        keepZeroAndEmpty={false}
                        showBlurZero={false}
                        error={immManagementPlan.get('errorFlags')}
                        errorMsg={formatText(
                            'rainput-amoutInputMinimumValidation',
                            injectedStrings,
                        )}
                    />
                    <span className="ra-scheme-setting-contribution__amount-input-symbol">
                        {EURO_SYMBOL}
                    </span>
                </div>
            </div>
        );
    }

    buildContributionPeriodicity(
        contributionAmount,
        periodicity,
        contributionDay,
    ) {
        const { immManagementPlan } = this.props;
        const disableSelect = contributionAmount < 1;

        return (
            <div className="ra-management-plan-view__contribution-periodicity">
                <div className="ra-management-plan-view__info">
                    <FormattedText
                        className="ra-management-plan-view__primary-info"
                        value="raSchemeSettingContribution-primaryInfo"
                    />
                    <FormattedText
                        className="ra-management-plan-view__secondary-info"
                        value="raSchemeSettingContribution-secondaryInfo"
                    />
                </div>
                <RAContributionPeriodicity
                    amount={contributionAmount}
                    selectedDay={contributionDay}
                    selectedPeriodicity={periodicity}
                    onDayClick={this.handleContributionDayChange}
                    onPeriodicityChange={this.handlePeriodicityChange}
                    onRecurringContributionChange={
                        this.handleRecurringContributionChange
                    }
                    errorState={immManagementPlan.get('recurringAmountError')}
                    errorMessage={formatText(
                        'raHireManagementPlanStep2-errorMessage',
                    )}
                    keepZeroAndEmpty={false}
                    disableSelect={disableSelect}
                    hideFocusZero={true}
                />
            </div>
        );
    }

    buildMessage() {
        this.props.notificationSuccess(formatText('raManagementPlan-saveMsg'));
        this.setState({ msgFlag: false });
    }

    buildLegalTextForContactCenter() {
        const { immProfile } = this.props;
        const fullname = immProfile.get('fullname');
        return (
            <BlockInfo extraClass="ra-management-plan-view-legal-text__block-info">
                <p>
                    <FormattedText
                        value="raManagementPlanView-legalTextP1"
                        injectedStrings={[fullname]}
                    />
                </p>
            </BlockInfo>
        );
    }

    buildMoreinfoLinks() {
        const {
            immFlagBasedFeatures,
            immProfile,
            immGlobalVariables,
        } = this.props;
        const originCountry = immProfile.get('originCountry');
        const precontractURL =
            immGlobalVariables.getIn([
                'variables',
                'parameters',
                'contratos',
                'precontractuales_robo',
            ]) || '';

        const links = [
            ...(immFlagBasedFeatures.get(ROBO_PRECONTRACT) ? (
                <OKLink
                    modifier="emphasize"
                    key={0}
                    to={precontractURL}
                    target="_blank"
                >
                    <FormattedText value="raManagementPlan-moreInfoText4Link" />
                </OKLink>
            ) : (
                []
            )),
            <OKLink
                modifier="emphasize"
                key={1}
                onClick={() => this.handleManagementPDFClick()}
            >
                <FormattedText value="raManagementPlan-moreInfoText3Link" />
            </OKLink>,
        ];
        const moreInfoText = `raManagementPlan-moreInfoText3_${originCountry}`;

        return (
            <FormattedTextWithComponents
                value={moreInfoText}
                injectedComponents={links}
            />
        );
    }

    buildDetailsSection(
        immExpectedProfitability,
        donutContent,
        tableContent,
        investProfileValue,
        wealthRoboStrategiesEnabled,
    ) {
        const { immManagementPlan } = this.props;

        const chartButtons = immExpectedProfitability
            .get('chartButtons')
            .toJS();
        const chartYears = immExpectedProfitability.get('chartYears');
        const chartData = immExpectedProfitability
            .getIn(['productsChartData', `${investProfileValue - 1}`])
            .toJS();
        const chartDataFetching = immExpectedProfitability.get('isFetching');

        const strategyName = `raPortfolioDistribution-strategy${investProfileValue}`;
        const strategyIcon = `ra-management-plan-view__icon ra-management-plan-view__icon--${investProfileValue}`;
        let graph;
        const initialContributionAmount = immManagementPlan.get(
            'initialContributionAmount',
        );
        const recurringContributionAmount = immManagementPlan.get(
            'recurringContributionAmount',
        );
        const initialContributionAmountError = immManagementPlan.get(
            'initialContributionAmountError',
        );
        const recurringAmountError = immManagementPlan.get(
            'recurringAmountError',
        );
        const message = this.state.msgFlag ? this.buildMessage() : null;
        const legalTextForCC = __CONTACT_CENTER__
            ? this.buildLegalTextForContactCenter()
            : null;

        if (
            (initialContributionAmount || recurringContributionAmount) &&
            !initialContributionAmountError &&
            !recurringAmountError
        ) {
            graph = (
                <RAExpectedProfitability
                    changeYears={this.handleProjectionChartYearsClick} // eslint-disable-line
                    chartButtons={chartButtons}
                    chartData={chartData}
                    chartYears={chartYears}
                    loading={chartDataFetching}
                    title={formatText('rentabilityGraph-expectedRentability')}
                    subtitle={formatText(
                        'rentabilityGraph-expectedRentabilityDescription',
                    )}
                />
            );
        }

        return (
            <div
                className="row ra-management-plan-view__detail-section"
                id="raManagementPlanViewDetailsAnchor"
            >
                {!wealthRoboStrategiesEnabled && (
                    <div className="col-md-12">
                        <div className="ra-management-plan-view__detail-section-title">
                            <i className={strategyIcon} />
                            <FormattedText value={strategyName} />
                        </div>
                        {graph}
                    </div>
                )}
                <div
                    className="col-md-12"
                    id="raManagementPlanViewDetailsAnchor"
                >
                    <div className="ra-management-plan-view__section-donut-tabs">
                        <h3 className="ra-management-plan-view__section-title">
                            <FormattedText value="raManagementPlanView-distributionTitle" />
                        </h3>
                        <FormattedText
                            value="raManagementPlanView-distributionInfo"
                            className="ra-management-plan-view__section-info"
                        />
                        {legalTextForCC}
                        {donutContent}
                    </div>
                    {!wealthRoboStrategiesEnabled && (
                        <div className="ra-management-plan-view__section-table">
                            <h3 className="ra-management-plan-view__section-title">
                                <FormattedText value="raManagementPlanView-distributionDetailsTitle" />
                            </h3>
                            <FeatureTogglingRender
                                notAllowedProductKey={ESG_PRODUCT}
                            >
                                <div className="ra-management-plan-view__section-esg-tag">
                                    <i className="ra-management-plan-view__section-esg-icon" />
                                    <FormattedText value="raManagementPlanView-raManagementPlanView_esgTag" />
                                </div>
                            </FeatureTogglingRender>
                            <div className="ra-management-plan-view__table-container">
                                {tableContent}
                            </div>
                            <div className="ra-management-plan-view__more-info-link">
                                <p>{this.buildMoreinfoLinks()}</p>
                            </div>
                            {message}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    handleTitleChange(event) {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_MODIFY_OBJECTIVE_NAME,
        );
        this.props.setInvestmentGoalValue(
            'investmentTitle',
            __CONTACT_CENTER__ ? event.target.value : event,
        );
    }

    handleTitleFocus() {
        this.setState({
            titleEditor: true,
        });
    }

    handleTitleBlur(event) {
        this.props.setInvestmentGoalValue(
            'investmentTitle',
            event.target.value,
        );
        this.setState({
            titleEditor: false,
        });
    }

    handleAmountChange(value) {
        this.props.setInvestmentGoalValue('investmentAmount', value);
        this.requestBarChart();
    }

    handleDateChange(value) {
        this.props.setInvestmentGoalValue('investmentDate', value);
        this.props.setTimeHorizonCheck(
            value.format(DATE_FORMAT_TIME_HORIZON_CHECK),
        );
        if (value) {
            this.props.timeHorizonCheck(() => {}, this.shortStrategyNumber);
            this.requestBarChart();
        }
    }

    handleEndDateError() {
        const { immCustomPlanByObjective } = this.props;
        if (!immCustomPlanByObjective.get('objectiveEndDateError')) {
            this.props.setObjectiveEndDateError();
        }
    }

    handleStrategyClick(value) {
        const { selectStrategy, updateCustomName } = this.props;
        selectStrategy(value);
        updateCustomName(value);
        this.requestLineChart();
    }

    buildAmountSection() {
        const { immCustomPlanByObjective, immSetGoal } = this.props;
        const investmentAmount = immCustomPlanByObjective.get(
            'objectiveAmount',
        );
        const immStep = immSetGoal.getIn(['steps', SECOND_STEP]);
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];
        return (
            <div className="ra-management-plan-view__section-amount">
                <AmountInput
                    amount={investmentAmount}
                    callback={this.handleAmountChange} // eslint-disable-line
                    max={RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT}
                    label={formatText('raSetGoal-goalAmountTitle')}
                    language={getLanguage()}
                    hideFocusZero={true}
                    error={immStep.get('errorFlags')}
                    errorMsg={formatText(
                        'rainput-amoutInputMinimumValidation',
                        injectedStrings,
                    )}
                />
                <span className="ra-management-plan-view__currency">
                    {EURO_SYMBOL}
                </span>
            </div>
        );
    }

    buildCustomCalender() {
        const { immCustomPlanByObjective } = this.props;
        let investmentDate = immCustomPlanByObjective.get('objectiveEndDate');
        const dateLabel = formatText('raSetGoal-calenderText');
        const minDate = moment()
            .startOf('day')
            .add(1, 'day')
            .add(1, 'years');
        const maxDate = moment()
            .startOf('day')
            .add(RA_DATEPICKER_MAXIMUM_YEARS, 'years');

        return (
            <div className="ra-management-plan-view__section-invest-calendar">
                <div className="ra-management-plan-view__section-invest-calendar-label">
                    {dateLabel}
                </div>
                <div key={investmentDate === null}>
                    <OKDatePicker
                        callback={this.handleDateChange} // eslint-disable-line
                        callbackError={this.handleEndDateError} // eslint-disable-line
                        selectedDate={investmentDate}
                        newSelectedDate={investmentDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        startDate={minDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        messageStandardErrorDate={formatText(
                            'raDatePicker-raDatePicker_standardDateError',
                        )}
                        messageLessThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_lessThanMinDateError',
                        )}
                        messageMoreThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_moreThanMaxDateError',
                        )}
                        defaultPlaceholder={formatText(
                            'datePickerCustom-defaultPlaceholder',
                        )}
                        defaultPlaceholderDay={formatText(
                            'datePickerCustom-defaultPlaceholderDay',
                        )}
                        defaultPlaceholderMonth={formatText(
                            'datePickerCustom-defaultPlaceholderMonth',
                        )}
                        defaultPlaceholderYear={formatText(
                            'datePickerCustom-defaultPlaceholderYear',
                        )}
                    />
                </div>
            </div>
        );
    }

    buildInvestmentContent() {
        const {
            immCustomPlanByObjective,
            immPortfoliosNameHistory,
            immManagementPlan,
        } = this.props;
        const investmentTitle = immCustomPlanByObjective.get('objectiveType')
            ? immCustomPlanByObjective.get('objective')
            : '';
        const selectedGoal = immCustomPlanByObjective.get('objectiveType');
        const extraContent = !selectedGoal ? (
            <i className="icon-nuevos-objetivos icon ra-set-goal-step2__goal-icon" />
        ) : null;
        const placeholder = formatText('raSetGoal-goalTitlePlaceHolder');
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const objectiveName = immCustomPlanByObjective.get('objective');

        const selectedStrategy = immManagementPlan.get('investProfileValue');

        const editIconClassName = classnames(
            'ra-management-plan-view__icon-edit icon-editar',
            {
                'ra-management-plan-view__icon-edit--disabled':
                    investmentTitle.length === 0,
            },
        );

        const amountSectionBlock = this.buildAmountSection();
        const calenderSectionBlock = this.buildCustomCalender();
        const disableGoalNameInput = !selectedGoal;
        const sectionInvestClassName = classnames(
            'ra-management-plan-view__section-invest',
            {
                'ra-management-plan-view__section-invest--disabled':
                    disableGoalNameInput || selectedStrategy === 0,
            },
        );
        const errorName =
            namesHistory &&
            namesHistory.find(
                names =>
                    names &&
                    names.toLowerCase() === objectiveName.toLowerCase(),
                false,
            );
        const emptyNameError = objectiveName === '' && !!selectedGoal;
        let errorMessage = 'raManagementPlan-raManagementPlan_customNameError';
        if (emptyNameError) {
            errorMessage =
                'raManagementPlan-raManagementPlan_customNameEmptyError';
        }

        return (
            <div className={sectionInvestClassName}>
                <RAImageButton
                    extraClass="ra-set-goal-step2__section-invest--goal-icon"
                    extraContent={extraContent}
                    iconType={selectedGoal}
                    isSelected={true}
                    size="small"
                    extraClassForGoalWrapper="ra-management-plan-view__section-invest--goal-icon"
                />
                <WebappRender>
                    <div className="ra-management-plan-view__section-invest--goal-value ra-management-plan-view__placeholder">
                        <h1 className="profile-picture-editor__alias-edit">
                            <BrokerEditAlias
                                alias={investmentTitle}
                                aliasPlaceHolder={formatText(
                                    'raManagementPlan-raManagementPlan_objectiveNamePlaceholder',
                                )}
                                allowEmptyAlias={true}
                                allowMaxLength={true}
                                limit={50}
                                postAlias={this.handleTitleChange} // eslint-disable-line
                                fontSize={BROKER_ROBO_EDIT_FIELD_FONT}
                                error={errorName || emptyNameError}
                                errorMessage={formatText(errorMessage)}
                            />
                        </h1>
                    </div>
                </WebappRender>
                <ContactCenterRender>
                    <div className="ra-management-plan-view__section-invest--goal-value">
                        <OKInput
                            autoComplete="off"
                            value={investmentTitle}
                            onBlur={this.handleTitleBlur}
                            onFocus={this.handleTitleFocus}
                            onChange={this.handleTitleChange}
                            maxLength="50"
                            placeholder={placeholder}
                        />
                        <i className={editIconClassName} />
                    </div>
                </ContactCenterRender>
                {amountSectionBlock}
                {calenderSectionBlock}
            </div>
        );
    }

    buildImageButtons() {
        const goalSelected = this.props.immCustomPlanByObjective.get(
            'objectiveType',
        );

        const GOALS = [
            {
                id: 'car',
                title: formatText('raSetGoal-goalCoche'),
            },
            {
                id: 'home',
                title: formatText('raSetGoal-goalCasa'),
            },
            {
                id: 'travel',
                title: formatText('raSetGoal-goalViaje'),
            },
            {
                id: 'education',
                title: formatText('raSetGoal-goalEducacion'),
            },
            {
                id: 'others',
                title: formatText('raSetGoal-goalOtro'),
            },
        ];

        const content = GOALS.map((goal, index) => {
            const title = goal.title;
            const isSelected = goal.id === goalSelected;
            const id = goal.id;
            const extraClass = isSelected
                ? 'ra-management-plan-view__accordion-icon'
                : '';

            return (
                <RAImageButton
                    label={title}
                    iconType={id}
                    extraClass={extraClass}
                    id={id}
                    key={title + `-` + index}
                    isSelected={isSelected}
                    size="medium"
                />
            );
        });

        return content;
    }

    buildStrategyGraph(
        immManagementPlan,
        immCustomPlanByObjective,
        immExpectedProfitability,
        immSuitabilityTest,
        immTimeHorizonCheck,
    ) {
        const selectedStrategy = immManagementPlan.get('investProfileValue');
        const strategyName = formatText(
            `raStrategyItem-raStrategyItem_${selectedStrategy}`,
        );
        return (
            <div className="ra-management-plan-view__strategy-graph">
                <div className="ra-management-plan-view__strategy-header">
                    <FormattedText
                        value="raManagementPlanView-raManagementPlanView_strategyGraphHeader"
                        className="ra-management-plan-view__accordion-header"
                        injectedStrings={[strategyName]}
                    />
                </div>
                <RAStrategiesGraph
                    goal={immCustomPlanByObjective.get('objectiveAmount')}
                    immExpectedProfitability={immExpectedProfitability}
                    initialContributionAmount={immManagementPlan.get(
                        'initialContributionAmount',
                    )}
                    objectiveEndDate={immCustomPlanByObjective.get(
                        'objectiveEndDate',
                    )}
                    maxAvailableInvestmentProfile={immTimeHorizonCheck.get(
                        'maxTypeOfProduct',
                    )}
                    maxInvestmentProfile={immSuitabilityTest.getIn(
                        ['results', 0, 'maxTypeOfProduct'],
                        0,
                    )}
                    selectedStrategy={selectedStrategy}
                    singleStrategy={true}
                    showDescription={true}
                />
            </div>
        );
    }

    buildStrategyGraphMessage() {
        return (
            <div className="ra-management-plan-view__message-section">
                <OKMessage type="informative">
                    <FormattedText
                        value={`raStrategiesGraph-raStrategiesGraph_investmentExceedThanGoalMessage`}
                    />
                </OKMessage>
            </div>
        );
    }

    buildStrategyResetButton() {
        return (
            <OKButton
                modifier="ghost"
                size="small"
                leftIcon="icon-limpiar_objetivo"
                onClick={this.handleStrategyResetClick}
            >
                <FormattedText value="raGlobal-raGlobal_resetStrategyButton" />
            </OKButton>
        );
    }

    buildGoalResetButton() {
        return (
            <div className="ra-management-plan-view__accordion-header-button">
                <OKButton
                    modifier="ghost"
                    size="small"
                    leftIcon="icon-limpiar_objetivo"
                    onClick={this.handleGoalResetClick}
                >
                    <FormattedText value="raGlobal-raGlobal_resetGoalButton" />
                </OKButton>
            </div>
        );
    }

    buildGoalSection(
        includeGoal,
        immManagementPlan,
        immCustomPlanByObjective,
        immExpectedProfitability,
        immSuitabilityTest,
        immTimeHorizonCheck,
    ) {
        const content = this.buildImageButtons();
        const iconInvestmentSectionBlock = this.buildInvestmentContent();
        const selectedStrategy = immManagementPlan.get('investProfileValue');
        const initialContributionAmount = immManagementPlan.get(
            'initialContributionAmount',
        );
        const objectiveType = immCustomPlanByObjective.get('objectiveType');
        const objectiveAmount = immCustomPlanByObjective.get('objectiveAmount');
        const immProductsChartData = immExpectedProfitability.get(
            'barChartData',
        );
        const status = immTimeHorizonCheck.get('status');
        let contribution;

        if (immProductsChartData) {
            contribution = immProductsChartData.getIn([
                0,
                1,
                'contributionNet',
            ]);
        }
        const displayStrategyMessage =
            (contribution > objectiveAmount ||
                initialContributionAmount > objectiveAmount) &&
            ![
                TIME_HORIZON_CHECK_NOT_PERFORMED,
                TIME_HORIZON_CHECK_ERROR,
                TIME_HORIZON_CHECK_WARNING,
            ].includes(status);
        const strategyMessageContent = displayStrategyMessage
            ? this.buildStrategyGraphMessage()
            : null;

        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const hasStrategyGraphData =
            !!initialContributionAmount &&
            !!objectiveAmount &&
            !!objectiveEndDate &&
            !immTimeHorizonCheck.get('isFetching');
        let strategyGraph;
        if (
            !!selectedStrategy &&
            !!immExpectedProfitability.get('barChartData') &&
            hasStrategyGraphData
        ) {
            strategyGraph = this.buildStrategyGraph(
                immManagementPlan,
                immCustomPlanByObjective,
                immExpectedProfitability,
                immSuitabilityTest,
                immTimeHorizonCheck,
            );
        }

        const goalResetButton = !!objectiveType
            ? this.buildGoalResetButton()
            : null;
        if (displayStrategyMessage) {
            this.props.resetScrollHeight();
        }

        return (
            <Accordion
                customClassName="ra-management-plan-view__accordion"
                isExpanded={includeGoal}
                ref={componentInstance => {
                    this.raGoalSectionHeader = componentInstance;
                }}
                onClick={this.handleAccordionObjectivesClick}
            >
                <AccordionHeader name="AccordionHeader">
                    <div className="ra-management-plan-view__accordion-header-wrapper">
                        <FormattedText
                            value="raManagementPlan-raManagementPlan_goalHeader"
                            className="ra-management-plan-view__accordion-header"
                        />
                        {goalResetButton}
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="ra-management-plan-view__accordion-container">
                        <RAImageButtonGroup
                            onChange={this.handleGetImageClicked}
                            extraClass="ra-management-plan-view__image-button-group"
                        >
                            {content}
                        </RAImageButtonGroup>
                        <div className="ra-management-plan-view__accordion-form">
                            {iconInvestmentSectionBlock}
                            <RATimeHorizonCheck />
                            {strategyMessageContent}
                        </div>
                    </div>
                    {strategyGraph}
                </AccordionBody>
            </Accordion>
        );
    }

    shouldDisableFinishButton(wealthRoboStrategiesEnabled) {
        const {
            immTimeHorizonCheck,
            immCustomPlanByObjective,
            immManagementPlan,
            immSetGoal,
            immPortfoliosNameHistory,
        } = this.props;
        const maxInvestProfileValue = immTimeHorizonCheck.get(
            'maxTypeOfProduct',
        );
        const candidateProfileValue = immManagementPlan.get(
            'investProfileValue',
        );
        const investProfileValue =
            maxInvestProfileValue >= candidateProfileValue
                ? candidateProfileValue
                : '';
        const statusTimeHorizonCheck = immTimeHorizonCheck.get('status');
        const selectedGoal = !!immCustomPlanByObjective.get('objectiveType');
        const disabled =
            investProfileValue === RA_NO_STRATEGY_SELECTED ||
            immManagementPlan.get('initialContributionAmount') <
                MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT ||
            immManagementPlan.get('errorFlags') ||
            immManagementPlan.get('recurringAmountError') ||
            (statusTimeHorizonCheck === TIME_HORIZON_CHECK_ERROR &&
                selectedGoal) ||
            immPortfoliosNameHistory
                .get('namesHistory')
                .find(
                    names =>
                        names.toLowerCase() ===
                        immManagementPlan
                            .get('portfolioCustomName')
                            .toLowerCase(),
                    false,
                );
        let disabledByGoal = selectedGoal;

        if (selectedGoal) {
            disabledByGoal =
                !immCustomPlanByObjective.get('objective') ||
                !immCustomPlanByObjective.get('objectiveAmount') ||
                !immCustomPlanByObjective.get('objectiveEndDate') ||
                immCustomPlanByObjective.get('objectiveEndDateError') ||
                immSetGoal.getIn(['steps', SECOND_STEP, 'errorFlags']) ||
                immPortfoliosNameHistory
                    .get('namesHistory')
                    .find(
                        names =>
                            names.toLowerCase() ===
                            immCustomPlanByObjective
                                .get('objective')
                                .toLowerCase(),
                        false,
                    );
        }

        if (wealthRoboStrategiesEnabled) {
            return (
                investProfileValue === 0 ||
                investProfileValue === RA_NO_STRATEGY_SELECTED
            );
        }

        return disabled || disabledByGoal;
    }

    buildModal() {
        return (
            <RAIndexRiskModal
                isModalOpen={this.state.isModalOpen}
                onModalClose={this.handleCloseModal}
            />
        );
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false,
        });
    }

    handleOnLinkClick() {
        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_RISK_INDEX,
            PROC_RA_MANAGMENT_PLAN_OPEN_MODAL,
        );
        this.setState({
            isModalOpen: true,
        });
    }

    handleSaveSimulation(wealthRoboStrategiesEnabled) {
        const eventTag = wealthRoboStrategiesEnabled
            ? PROC_RA_MANAGMENT_PLAN_SAVE
            : undefined;

        recordLink(
            PROC_RA_MANAGMENT_PLAN,
            PROC_RA_MANAGMENT_PLAN_SAVE_STRATEGY,
            eventTag,
        );

        this.props.saveSimulationRequest(this.props.history, true);
        this.setState({
            msgFlag: true,
        });
        this.props.disableSaveSimulationButton(true);
    }

    setSaveSimulationButtonEnabled() {
        this.setState({
            msgFlag: false,
        });
        this.props.disableSaveSimulationButton(false);
    }

    handleSaveModalClose() {
        this.props.saveSimulationChangeModalOption(false);
        this.props.disableSaveSimulationButton(false);
    }

    handleDeleteSimulation() {
        const { immTimeHorizonCheck } = this.props;
        this.props.resetMaxTypeOfProduct();
        this.props.resetValueOfSaveSimulation();
        this.handleStrategyClick(immTimeHorizonCheck.get('maxTypeOfProduct'));
    }

    buildSaveSimulationModal() {
        const {
            deleteSimulation,
            immManagementPlan,
            immSaveSimulation,
        } = this.props;
        const showEditModal =
            !immManagementPlan.get('isEditClicked') &&
            immManagementPlan.get('isSaveSimulationModalOpen');
        return (
            <RASaveSimulationModal
                link={MANAGEMENT_PLAN_URL}
                isModalOpen={showEditModal}
                onModalClose={this.handleSaveModalClose}
                deleteSimulation={deleteSimulation}
                immManagementPlan={immManagementPlan}
                immSaveSimulation={immSaveSimulation}
                resetValueOfSaveSimulation={this.handleDeleteSimulation} // eslint-disable-line
                isObjective={false}
            />
        );
    }

    buildStrategyDetailModal(tableContent) {
        const { showStrategyDetailModal } = this.state;

        return (
            <RAStrategyDetailModal
                isModalOpen={showStrategyDetailModal}
                tableContent={tableContent}
                moreInfoLinks={this.buildMoreinfoLinks()}
                onModalClose={this.handleStrategyModalClose}
            />
        );
    }

    sendTagging(totalWantToInvestUrl) {
        taggingEventHandled(
            RA_MANAGEMENT_PLAN,
            'management_plan_total_want',
            totalWantToInvestUrl,
        );
    }

    handleCloseModalMaintenance() {
        recordLinkV2({
            action: 'click',
            format: 'button',
            component: 'modal/technicalUpdateDeferOperations',
            element: 'understood',
            eventCategory: PROC_RA_MANAGMENT_PLAN,
            eventAction: 'technicalUpdateDeferOperations',
            eventLabel: 'understood',
        });
        this.setState({
            openModalMaintenance: false,
        });
    }

    render() {
        const {
            immManagementPlan,
            immPortfolioDistribution,
            immCustomPlanByObjective,
            immExpectedProfitability,
            immPortfoliosNameHistory,
            immSuitabilityTest,
            immTimeHorizonCheck,
            immProfile,
            immFlagBasedFeatures,
            immCheckStatus,
        } = this.props;

        const portfolioCustomName = immManagementPlan.get(
            'portfolioCustomName',
        );
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const maxInvestProfileValue = immTimeHorizonCheck.get(
            'maxTypeOfProduct',
        );
        const candidateProfileValue = immManagementPlan.get(
            'investProfileValue',
        );
        const isSaveSimulationModalOpen = immManagementPlan.get(
            'isSaveSimulationModalOpen',
        );
        const investProfileValue =
            maxInvestProfileValue >= candidateProfileValue &&
            !!candidateProfileValue
                ? candidateProfileValue
                : 0;
        const initialContributionAmount = immManagementPlan.get(
            'initialContributionAmount',
        );
        const recurringContributionAmount = immManagementPlan.get(
            'recurringContributionAmount',
        );
        const periodicity = immManagementPlan.get('periodicity');
        const contributionDay = immManagementPlan.get(
            'recurringContributionDay',
        );
        const immAssetAllocations = immPortfolioDistribution.getIn([
            'portfolio',
            investProfileValue.toString(),
            'assetAllocations',
        ]);
        const selectedGoal = immCustomPlanByObjective.get('objectiveType');
        const includeGoal = !!selectedGoal;
        const investProfileDescription = immSuitabilityTest.getIn(
            ['results', 0, 'clientRiskProfileTitle'],
            '',
        );
        let donutContent, tableContent, strategyContent;
        const featureModal = this.buildFeatureModal();

        const saveSimulationModal =
            isSaveSimulationModalOpen &&
            immManagementPlan.get('isFetchedInvestProfile') &&
            !immTimeHorizonCheck.get('isFetching')
                ? this.buildSaveSimulationModal()
                : null;
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const email = PersonalDataHelper.getEmail(immProfile);
        const mappingBreadcrumb = [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText(
                    'raManagementPlan-raManagementPlan_breadcrumbSecond',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText(
                    'raManagementPlan-raManagementPlan_breadcrumbThird',
                ),
                url: '',
            },
        ];
        const ffWealthRoboStrategies = immFlagBasedFeatures.get(
            'not_allowed_wealth_robo_strategies_combo_countries',
        );

        const wealthRoboStrategiesEnabled =
            !!ffWealthRoboStrategies &&
            !ffWealthRoboStrategies.includes(immProfile.get('originCountry'));

        const buttonDisabled = this.shouldDisableFinishButton(
            wealthRoboStrategiesEnabled,
        );

        if (
            immManagementPlan.get('isFetchingInvestProfile') ||
            immTimeHorizonCheck.get('isFetching')
        ) {
            strategyContent = <LoadingSection />;
        } else {
            const renderStrategyCards = () => {
                const commonProps = {
                    maxAvailable: maxInvestProfileValue,
                    selectedCard: investProfileValue,
                    selectStrategy: this.handleStrategyClick, // eslint-disable-line
                    investProfileDescription,
                    clientName,
                };

                if (wealthRoboStrategiesEnabled) {
                    const handleDetailsClick = () => {
                        if (!immPortfolioDistribution.get('isFetching')) {
                            this.handleStrategyDetailsClick(
                                wealthRoboStrategiesEnabled,
                            );
                        }
                    };

                    return (
                        <RARoboStrategyCards
                            {...commonProps}
                            onStrategyDetailsClick={handleDetailsClick}
                        />
                    );
                }

                return (
                    <RAStrategyCards
                        {...commonProps}
                        onStrategyDetailsClick={() =>
                            this.handleStrategyDetailsClick()
                        }
                    />
                );
            };

            strategyContent = <div>{renderStrategyCards()}</div>;
        }

        if (immPortfolioDistribution.get('isFetching')) {
            donutContent = <LoadingSection />;
            tableContent = <LoadingSection />;
        } else {
            if (immAssetAllocations) {
                donutContent = (
                    <>
                        <RAPortfolioDonut
                            immAssetAllocations={immAssetAllocations}
                        />
                        {wealthRoboStrategiesEnabled && (
                            <div className="ra-management-plan-view__detail-button">
                                <OKButton
                                    modifier="secondary"
                                    onClick={this.handleStrategyDetailsClick}
                                >
                                    <FormattedText value="raManagementPlanView-strategyDetailButton" />
                                </OKButton>
                            </div>
                        )}
                    </>
                );
                tableContent = (
                    <RAPortfolioCompositionTable
                        immAssetAllocations={immAssetAllocations}
                        immManagementPlan={immManagementPlan}
                        flagBasedFeatures={immFlagBasedFeatures}
                        onHoverTooltip={this.handleOnHoverLiquidity}
                        hideLastRow={wealthRoboStrategiesEnabled}
                    />
                );
            }
        }

        const modalStrategyDetail = this.buildStrategyDetailModal(tableContent);
        const customNameInput = this.buildCustomNameInput(
            portfolioCustomName,
            namesHistory,
        );
        const initialInvestmentInput = this.buildInitialInvestmentInput(
            initialContributionAmount,
        );
        const contributionPeriodicity = this.buildContributionPeriodicity(
            recurringContributionAmount,
            periodicity,
            contributionDay,
        );
        let detailsSection;
        if (investProfileValue > 0 && !immTimeHorizonCheck.get('isFetching')) {
            detailsSection = this.buildDetailsSection(
                immExpectedProfitability,
                donutContent,
                tableContent,
                investProfileValue,
                wealthRoboStrategiesEnabled,
            );
        }

        let accordionGoal;
        if (!immManagementPlan.get('isFetchingInvestProfile')) {
            accordionGoal = this.buildGoalSection(
                includeGoal,
                immManagementPlan,
                immCustomPlanByObjective,
                immExpectedProfitability,
                immSuitabilityTest,
                immTimeHorizonCheck,
            );
        } else {
            accordionGoal = <LoadingSection />;
        }

        const modal = this.state.isModalOpen ? this.buildModal() : null;
        const loadingButton = immTimeHorizonCheck.get('isFetching');
        const showStrategyResetButton =
            !!investProfileValue ||
            !!initialContributionAmount ||
            !!recurringContributionAmount ||
            !!selectedGoal;

        const strategyResetButton = showStrategyResetButton
            ? this.buildStrategyResetButton()
            : null;
        let commisionCondition;
        if (
            immFlagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission')
        ) {
            commisionCondition = (
                <div className="ra-management-plan-view__footer-element-down">
                    <RACommissionCondition modifier={true} />
                </div>
            );
        }

        const ffUsPersonRoboadvisorHireUs = immFlagBasedFeatures.get(
            'wealth_roboadvisor_hire_us_person',
        );

        const totalWantToInvestUrl = formatText(
            'raManagementPlan-totalWantToInvestUrl',
        );

        const totalWantToInvestTargetUrl = formatText(
            'raManagementPlan-totalWantToInvestTargetUrl',
        );

        const renderLink = totalWantToInvestUrl && (
            <OKLink
                to={totalWantToInvestUrl}
                modifier="complementary"
                inverse={false}
                onClick={() => this.sendTagging(totalWantToInvestUrl)}
                target={
                    totalWantToInvestTargetUrl
                        ? totalWantToInvestTargetUrl
                        : '_blank'
                }
            >
                <FormattedText value="raManagementPlan-totalWantToInvestLinkText" />
            </OKLink>
        );

        const renderRiskIndexLink = (
            <OKLink
                modifier="emphasize"
                onClick={this.handleOnLinkClick}
                extraClass="ra-management-plan-view__inversion-profile-link"
            >
                <FormattedText value="raRiskButton-raRiskButton_text" />
            </OKLink>
        );

        const renderPlanViewSectionHeader = () => {
            const renderHeaderContent = () => {
                if (wealthRoboStrategiesEnabled) {
                    return (
                        <FormattedText
                            value="raManagementPlan-investStrategyTitle"
                            className="ra-management-plan-view__inversion-strategy-profile-title"
                        />
                    );
                }

                return (
                    <>
                        <FormattedText
                            value="raManagementPlan-investProfileTitle"
                            className="ra-management-plan-view__inversion-profile-title"
                        />
                        <div className="ra-management-plan-view__section-button">
                            {strategyResetButton}
                            <div className="ra-management-plan-view__section-button-right">
                                <RARiskButton
                                    onClick={this.handleOnLinkClick}
                                />
                            </div>
                        </div>
                    </>
                );
            };

            return (
                <div className="ra-management-plan-view__section-header">
                    {renderHeaderContent()}
                </div>
            );
        };

        const PlanViewHeaderTitle = () => {
            const headerClass = classnames(
                'ra-management-plan-view__header-title',
                {
                    'ra-management-plan-view__header-title-robo': wealthRoboStrategiesEnabled,
                },
            );
            return (
                <div className={headerClass}>
                    <FormattedText value="raManagementPlan-title" />
                    {!wealthRoboStrategiesEnabled && <PlanViewHeaderButton />}
                </div>
            );
        };

        const PlanViewHeaderButton = () => (
            <div className="ra-management-plan-view__header-button">
                <OKButton
                    onClick={this.handleTimeHorizonCheck}
                    disabled={buttonDisabled}
                    loading={loadingButton}
                >
                    <FormattedText value="raManagementPlan-ctaButton" />
                </OKButton>
            </div>
        );

        const managementContainerClass = `row ra-management-plan-view__container--${
            wealthRoboStrategiesEnabled ? 'white' : 'salmon'
        }`;

        const ProfileSubtitle = () => (
            <div className="ra-management-plan-view__inversion-profile-subtitle">
                <FormattedText
                    value={
                        wealthRoboStrategiesEnabled
                            ? 'raManagementPlan-investStrategySubtitle'
                            : 'raManagementPlan-investProfileSubtitle'
                    }
                />
                {wealthRoboStrategiesEnabled && (
                    <>
                        <span className="ra-management-plan-view__space-between-elements"></span>
                        {renderRiskIndexLink}
                    </>
                )}
            </div>
        );

        const contentModal = (
            <div className="ra-management-plan-view__content-modal">
                <p>
                    <FormattedText value="raManagementPlan-descriptionOneMaintenanceModal" />
                </p>
                <p>
                    <FormattedText value="raManagementPlan-descriptionTwoMaintenanceModal" />
                </p>
            </div>
        );

        const contentRender = (
            <div className="ra-management-plan-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        {modal}
                        {featureModal}
                        {saveSimulationModal}
                        {modalStrategyDetail}
                        <RAEmailRequiredWarning
                            email={email}
                            clientName={clientName}
                        />
                        <OKModal
                            content={contentModal}
                            isOpen={this.state.openModalMaintenance}
                            onCloseCallback={this.handleCloseModalMaintenance}
                            onPrimaryButtonClick={
                                this.handleCloseModalMaintenance
                            }
                            primaryButtonText="raManagementPlan-maintenancePrimaryButton"
                            shouldCloseOnOverlayClick={false}
                            size="small"
                            descriptionAlignment="center"
                            title="raManagementPlan-titleMaintenanceModal"
                            titleAlignment="center"
                            footerType="action"
                        />
                        <RAOKCover
                            size="medium"
                            section="investment"
                            customClass="col-xs-12"
                        >
                            <div className="ra-management-plan-view__header">
                                <div className="ra-management-plan-view__header-breadcrumb">
                                    <OKBreadcrumb mapping={mappingBreadcrumb} />
                                </div>
                                <PlanViewHeaderTitle />
                                <div className="ra-management-plan-view__header-extra-content">
                                    <div
                                        className={`ra-management-plan-view__header-profile${wealthRoboStrategiesEnabled &&
                                            '-strategy'}`}
                                    >
                                        <div>
                                            <FormattedText
                                                value="raManagementPlan-inversorProfile"
                                                className={`${
                                                    wealthRoboStrategiesEnabled
                                                        ? 'ra-management-plan-view__header-profile-strategy-label'
                                                        : 'ra-management-plan-view__header-profile-label'
                                                }`}
                                            />
                                        </div>
                                        <div
                                            className={`${
                                                wealthRoboStrategiesEnabled
                                                    ? 'ra-management-plan-view__header-profile-strategy-type'
                                                    : 'ra-management-plan-view__header-profile-type'
                                            }`}
                                        >
                                            {investProfileDescription}
                                        </div>
                                    </div>
                                    {!wealthRoboStrategiesEnabled && (
                                        <div className="ra-management-plan-view__header-description">
                                            <FormattedText value="raManagementPlan-headerDescription" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </RAOKCover>
                    </div>
                </div>
                <div className={managementContainerClass}>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <FeatureTogglingRender
                                        notAllowedProductKey={ESG_PRODUCT}
                                    >
                                        <div className="ra-management-plan-view__section-header-esg">
                                            <OKMessage type="esg">
                                                <FormattedText value="raManagementPlan-esgHeader" />
                                            </OKMessage>
                                        </div>
                                    </FeatureTogglingRender>
                                    {renderPlanViewSectionHeader()}
                                    <ProfileSubtitle />
                                    {wealthRoboStrategiesEnabled && (
                                        <div className="ra-management-plan-view__section-profile-type">
                                            <FormattedText
                                                value="raManagementPlan-investProfileType"
                                                className="ra-management-plan-view__inversion-profile-type"
                                            />
                                        </div>
                                    )}
                                    {strategyContent}
                                </div>
                            </div>
                            {!wealthRoboStrategiesEnabled && (
                                <div className="row">
                                    <div className="col-md-12 ra-management-plan-view__section-total-amount-description">
                                        <div>
                                            <FormattedText
                                                value="raManagementPlan-totalWantToInvestTitle"
                                                className="ra-management-plan-view__total-want-invest-title"
                                            />
                                        </div>
                                        <div className="ra-management-plan-view__section-total-amount-paragraph">
                                            <FormattedText value="raManagementPlan-totalWantToInvestDescription" />
                                            {renderLink}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!wealthRoboStrategiesEnabled && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="ra-management-plan-view__widget">
                                            {customNameInput}
                                            <div className="ra-management-plan-view__widget-content">
                                                {initialInvestmentInput}
                                                {contributionPeriodicity}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div>{accordionGoal}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row ra-management-plan-view__container--salmon-light">
                    <div className="grid-view__body">
                        <div className="container-fluid">{detailsSection}</div>
                    </div>
                </div>
                <div
                    className="row ra-management-plan-view__container--blue"
                    ref={componentInstance => {
                        this.raCtaFooter = componentInstance;
                    }}
                >
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div
                                    className="col-md-12 ra-management-plan-view__footer"
                                    ref={componentInstance => {
                                        this.raFooter = componentInstance;
                                    }}
                                >
                                    <div className="ra-management-plan-view__footer-left-container">
                                        {commisionCondition}
                                    </div>
                                    <div className="ra-management-plan-view__footer-buttons">
                                        <div className="ra-management-plan-view__save-button">
                                            <OKButton
                                                onClick={() =>
                                                    this.handleSaveSimulation(
                                                        wealthRoboStrategiesEnabled,
                                                    )
                                                }
                                                disabled={immManagementPlan.get(
                                                    'isSaveSimulationButtonDisabled',
                                                )}
                                                loading={loadingButton}
                                                modifier="secondary"
                                                inverse={true}
                                            >
                                                <FormattedText value="raManagementPlan-saveStrategy" />
                                            </OKButton>
                                        </div>
                                        <OKButton
                                            onClick={() =>
                                                this.handleTimeHorizonCheck(
                                                    'footer',
                                                    wealthRoboStrategiesEnabled,
                                                )
                                            }
                                            disabled={buttonDisabled}
                                            loading={loadingButton}
                                        >
                                            <FormattedText value="raManagementPlan-ctaButton" />
                                        </OKButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (immManagementPlan.get('isFetchingValidateBlockedAccount')) {
            return <LoadingSection />;
        }

        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonRoboadvisorHireUs}
                titleKey={'us_person_popup-roboadvisor_contribution_title'}
                description={'us_person_popup-roboadvisor_contribution_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_ROBO_URL)}
            />
        );
    }
}

RAManagementPlanView.propTypes = {
    deleteSimulation: PropTypes.func.isRequired,
    disableSaveSimulationButton: PropTypes.func.isRequired,
    expectedProfitabilityChangeYears: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    getDisplayNames: PropTypes.func.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immPortfolioDistribution: PropTypes.object.isRequired,
    immPortfoliosNameHistory: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immSaveSimulation: PropTypes.object.isRequired,
    immSetGoal: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetGoal: PropTypes.func.isRequired,
    resetScrollHeight: PropTypes.func.isRequired,
    resetValueOfSaveSimulation: PropTypes.func.isRequired,
    saveSimulation: PropTypes.func.isRequired,
    saveSimulationRequest: PropTypes.func.isRequired,
    saveSimulationChangeModalOption: PropTypes.func.isRequired,
    selectStrategy: PropTypes.func.isRequired,
    setContributionDay: PropTypes.func.isRequired,
    setCustomName: PropTypes.func.isRequired,
    setInitialContributionAmount: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setRecurringContributionAmount: PropTypes.func.isRequired,
    showDetails: PropTypes.func.isRequired,
    setInvestmentGoalValue: PropTypes.func.isRequired,
    setInclutionGoal: PropTypes.func.isRequired,
    setObjectiveEndDateError: PropTypes.func.isRequired,
    setScrollHeight: PropTypes.func.isRequired,
    setTimeHorizonCheck: PropTypes.func.isRequired,
    timeHorizonCheck: PropTypes.func.isRequired,
    resetMaxTypeOfProduct: PropTypes.func.isRequired,
    updateCustomName: PropTypes.func.isRequired,
    updateGoalSelected: PropTypes.func.isRequired,
    notificationSuccess: PropTypes.func.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireManagementPlan: state.raHireManagementPlan,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immPortfoliosNameHistory: state.raPortfoliosNameHistory,
        immExpectedProfitability: state.raExpectedProfitability,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immGlobalVariables: state.globalVariables,
        immRAFeatureFlag: state.raFeatureFlag,
        immSaveSimulation: state.raSaveSimulation,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immSetGoal: state.raSetGoal,
        immProfile: state.profile,
        immCheckStatus: state.raCheckStatus,
        immGlobalPosition: state.raGlobalPosition,
    }),
    {
        deleteSimulation: raHireManagementPlanActions.deleteSimulation,
        expectedProfitabilityChangeYears:
            expectedProfitabilityActions.changeYears,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        getDisplayNames: raPortfoliosNameHistoryActions.getDisplayNames,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        getTestResult: raSuitabilityTestActions.getTestResult,
        notificationSuccess: notification.success,
        requestSimulation: raManagementPlanActions.requestSimulation,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        reset: raManagementPlanActions.reset,
        resetGoal: raCustomPlanByObjectiveActions.reset,
        resetMaxTypeOfProduct: raTimeHorizonCheckActions.resetMaxTypeOfProduct,
        resetScrollHeight: raManagementPlanActions.resetScrollHeight,
        resetValueOfSaveSimulation:
            raManagementPlanActions.resetValueOfSaveSimulation,
        saveSimulation: raManagementPlanActions.saveSimulation,
        saveSimulationRequest: raSaveSimulationActions.saveSimulationRequest,
        saveSimulationChangeModalOption:
            raManagementPlanActions.saveSimulationChangeModalOption,
        setInitialContributionAmount:
            raManagementPlanActions.setInitialContributionAmount,
        setContributionDay: raManagementPlanActions.setContributionDay,
        setCustomName: raManagementPlanActions.setCustomName,
        setPeriodicity: raManagementPlanActions.setPeriodicity,
        setRecurringContributionAmount:
            raManagementPlanActions.setRecurringContributionAmount,
        selectStrategy: raManagementPlanActions.selectStrategy,
        showDetails: raManagementPlanActions.showDetails,
        setInvestmentGoalValue: raSetGoalActions.setInvestmentGoalValue,
        setInclutionGoal: raManagementPlanActions.setInclutionGoal,
        setScrollHeight: raManagementPlanActions.setScrollHeight,
        setObjectiveEndDateError:
            raCustomPlanByObjectiveActions.setObjectiveEndDateError,
        setTimeHorizonCheck: raTimeHorizonCheckActions.setTimeHorizonCheck,
        timeHorizonCheck: raTimeHorizonCheckActions.timeHorizonCheck,
        updateCustomName: raManagementPlanActions.updateCustomName,
        updateGoalSelected: raSetGoalActions.updateGoalSelected,
        disableSaveSimulationButton:
            raManagementPlanActions.disableSaveSimulationButton,
        validateBlockedAccount: raManagementPlanActions.validateBlockedAccount,
    },
)(withRouter(RAManagementPlanView));
